<template>
    <div>Something went wrong, we can not sign you in</div>
</template>
<script>

export default {
    name: 'AuthenticationFailed'
}
</script>
